import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserRoleValue } from '@/types';

interface AuthUser {
  id: string;
  name: string;
  email: string;
  role: UserRoleValue;
  teacherStatus?: string | null;
}

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  refreshToken: string | null;
  setAuth: (user: AuthUser, token: string, refreshToken?: string | null) => void;
  updateToken: (token: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      refreshToken: null,
      setAuth: (user, token, refreshToken) => set({ user, token, refreshToken: refreshToken ?? null }),
      updateToken: (token) => set({ token }),
      clearAuth: () => set({ user: null, token: null, refreshToken: null }),
    }),
    {
      name: 'cardwise-auth',
      partialize: (state) => ({
        user: state.user ? { id: state.user.id, name: state.user.name, email: state.user.email, role: state.user.role, teacherStatus: state.user.teacherStatus } : null,
        token: state.token,
        refreshToken: state.refreshToken,
      }),
    },
  ),
);
